/* eslint-disable react/require-default-props */
import { Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Rating.scss';

type RatingProps = {
  rating: string;
  size?: string;
  open?: boolean;
  handleTooltipParent?: (string: string) => void;
};

const Rating = ({ rating, size = '', open = false, handleTooltipParent }: RatingProps) => {
  const [t] = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState('');
  const handleTooltip = (rate: string) => {
    setTooltipOpen(rate);
  };
  const getTooltip = () => {
    if (rating === 'A') return t('5');
    if (rating === 'B') return t('4');
    if (rating === 'C') return t('3');
    if (rating === 'D') return t('2');
    if (rating === 'E') return t('1');
    if (rating === 'S') return t('S');
    return '';
  };

  // useEffect(() => {
  //   if (tooltipOpen === (rating as string) && open && handleTooltipParent) handleTooltipParent('');
  // }, [handleTooltipParent, tooltipOpen]);
  return (
    <Tooltip
      title={getTooltip() as string}
      key={`${rating as string}`}
      open={tooltipOpen === (rating as string) && open}
      placement="top"
      PopperProps={{ style: { pointerEvents: 'none', marginTop: '30px', zIndex: 1564 } }}
    >
      <span
        onMouseEnter={() => {
          handleTooltip(rating as string);
        }}
        onMouseLeave={() => {
          handleTooltip('');
        }}
        onMouseOut={() => {
          handleTooltip('');
        }}
        onBlur={() => handleTooltip('')}
        className="tooltip-container"
      >
        <span className={`rate-container ${size}`}>
          <div translate="no" className={`rate ${rating} ${size}`}>
            {rating !== 'S' ? rating : 'Skip'}
          </div>
        </span>
      </span>
    </Tooltip>
  );
};

export default Rating;
